import React, { useState, useCallback } from 'react';
import axios from '../../axios';
import { useParams } from 'react-router-dom';
import M from 'materialize-css';
import Indeterminado from '../../Layout/Loaders/Indeterminado';

const NuevoPassword = () => {
    const {token} = useParams();
    const [data, setData] = useState({ password:'' ,password_confirmation: '', token:token, email:''});
    const [loader, setLoader] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);

        if (data.password === '' || data.password_confirmation === '' || data.email === '') {
            M.toast({
                html: `<i class="material-icons">sentiment_very_dissatisfied</i> &nbsp;&nbsp;<span>Todos los campos son obligatorios.</span>`,
                classes: "error-notify"
            });
            setLoader(false);
            return;
        }

        if (data.password !== data.password_confirmation) {
            M.toast({
                html: `<i class="material-icons">sentiment_very_dissatisfied</i> &nbsp;&nbsp;<span>La contraseña no coincide, verifica que sean iguales.</span>`,
                classes: "error-notify"
            });
            setLoader(false);
            return;
        }

        try {
            const res = await axios.post('/api/change_password', data);
            M.toast({
                html: `<i class="material-icons">sentiment_very_satisfied</i> &nbsp;&nbsp;<span>${res.data.message}</span>`,
                classes: "success-notify"
            });
        } catch (e) {
            const mensaje = e.response && e.response.data && e.response.data.message ? e.response.data.message : "Error desconocido";
            M.toast({
                html: `<i class="material-icons">sentiment_very_dissatisfied</i> &nbsp;&nbsp;<span>${mensaje}</span>`,
                classes: "error-notify"
            });
        } finally {
            setLoader(false);
        }
    };

    const showPassword = useCallback(() => {
        const passwordField = document.querySelector('#newpassword');
        passwordField.type = passwordField.type === 'password' ? 'text' : 'password';
    }, []);

    const showPasswordConfirmation = useCallback(() => {
        const passwordField = document.querySelector('#confirmpassword');
        passwordField.type = passwordField.type === 'password' ? 'text' : 'password';
    }, []);

    return (
        <>
        <div className='bg-principal'>
            {loader &&  <Indeterminado /> }
            <div className='bg-transparencia'>
                <div className='bg-transparencia'>
                    <div className='centrar' style={{marginTop:'-150px'}}>
                        <img className='login-img' src='../../images/logo2.png' alt='dento metric' />
                    </div>
                    <div className='cont-form-login'>
                        <div className='m-p-0 alto80 centrar'>
                            <div className="row m-p-0 ancho100">
                                <form className="col s12" id='login-form'  onSubmit={handleSubmit}>
                                    <div className="row m-p-0">
                                       <div className="row m-p-0">
                                            <h5>
                                                <img src='../../images/sesion.png' alt='dento metric' />
                                                Recupera tu contraseña
                                            </h5>            
                                            <div className='m-t-10'>Te sugerimos algo facil de recordar, pero no la compartas</div>
                                            <div className="input-field col s12" style={{ position: 'relative' }}>
                                                <input id="newpassword" type="password" className="validate" onChange={(e)=>setData({...data,password:e.target.value})}/>
                                                <label htmlFor="newpassword">Nuevo Password</label>
                                                <i className="tiny material-icons" style={{ position: 'absolute', top: 5, right: 10, color: 'blue' }} onClick={showPassword}>remove_red_eye</i>
                                            </div>
                                        </div>
                                        <div className="row m-p-0">
                                            <div className="input-field col s12" style={{ position: 'relative' }}>
                                                <input id="confirmpassword" type="password" className="validate" onChange={(e)=>setData({...data,password_confirmation:e.target.value})} />
                                                <label htmlFor="confirmpassword">Confirmar Password</label>
                                                <i className="tiny material-icons" style={{ position: 'absolute', top: 5, right: 10, color: 'blue' }} onClick={showPasswordConfirmation}>remove_red_eye</i>
                                            </div>
                                        </div>
                                        <div className="col s12">
                                            <div className="input-field" style={{ position: 'relative' }}>
                                                <input id="email" type="text" className="validate" onChange={(e)=>setData({...data,email:e.target.value})} />
                                                <label htmlFor="confirmpassword">Tu email</label>
                                            </div>
                                        </div>
                                        <div style={{ textAlign: "right" }}>
                                            <button className="btn waves-effect waves-light" type="submit" name="action">Cambiar Contraseña
                                                <i className="material-icons right">send</i>
                                            </button>
                                        </div>

                                    </div>  
                                </form>
                            </div> 
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default NuevoPassword;